import { Shield } from '@phosphor-icons/react';

const LegalDisclaimer = () => (
  <div
    data-testid="talent-legal-disclaimer"
    className="bg-[#FAFAF7] border border-[#E6E0D6] rounded-2xl p-6 mt-8"
    dir="rtl"
  >
    <div className="flex items-start gap-3">
      <Shield size={22} weight="duotone" className="text-[#4A641F] mt-0.5 shrink-0" />
      <div>
        <h4 className="font-bold text-[#1F3D2B] mb-2 font-['IBM_Plex_Sans_Arabic']">
          إخلاء المسؤولية القانونية
        </h4>
        <p className="text-sm text-[#6B7565] leading-8">
          لا تُقدّم Childhood Horizons خدمات توظيف أو تعيين أو وساطة وظيفية أو
          ضمان الحصول على عمل. يقتصر بنك الكفاءات على بناء الملفات المهنية
          للمستشارين المتعاونين، وتوثيق مسارهم المهني ضمن مجتمع مهني متخصص في
          الطفولة المبكرة. أي فرص تعاون مستقبلية داخل Childhood Horizons تخضع
          لموافقة صريحة من صاحب الملف قبل أي مشاركة أو تواصل خارجي، وفقاً
          لسياسة الخصوصية المعتمدة.
        </p>
      </div>
    </div>
  </div>
);

export default LegalDisclaimer;
